import React from 'react';
import { WebsiteDesignProps } from './types';
import { Lock, Shield, CreditCard, ChevronRight } from 'lucide-react';
import { Button } from "@/components/ui/button";

const FintechSecure: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Secure Finance Academy";

    return (
        <div className="bg-[#022c22] min-h-screen font-sans text-white">
            <nav className="container mx-auto px-6 py-6 flex justify-between items-center">
                <div className="text-xl font-bold tracking-tight flex items-center gap-2 text-[#34d399]">
                    <Shield className="fill-current" /> {schoolName}
                </div>
                <div className="hidden md:flex gap-8 text-sm font-medium text-emerald-100/80">
                    <a href="#" className="hover:text-white">Security</a>
                    <a href="#" className="hover:text-white">Courses</a>
                    <a href="#" className="hover:text-white">Certification</a>
                </div>
                <Button variant="ghost" className="text-[#34d399] hover:text-white hover:bg-[#064e3b]">Login</Button>
            </nav>

            <main className="container mx-auto px-6 py-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    <div>
                        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#064e3b] text-[#34d399] text-xs font-bold mb-6 border border-[#059669]">
                            <Lock size={12} /> BANK-GRADE EDUCATION
                        </div>
                        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                            Invest in your <br/> <span className="text-[#34d399]">Financial IQ.</span>
                        </h1>
                        <p className="text-lg text-emerald-100/70 mb-10 max-w-lg leading-relaxed">
                            The world's most trusted platform for financial literacy and wealth management education. Secure, verified, and accredited.
                        </p>
                        <div className="flex gap-4">
                            <Button className="bg-[#10b981] hover:bg-[#059669] text-white font-bold h-12 px-8 rounded-lg shadow-lg shadow-[#10b981]/20">
                                Start Investing
                            </Button>
                            <Button variant="link" className="text-white hover:text-[#34d399] h-12 px-0 font-bold flex items-center gap-1">
                                View Security Protocols <ChevronRight size={16} />
                            </Button>
                        </div>
                        
                        <div className="mt-12 flex items-center gap-6 opacity-60">
                            <CreditCard />
                            <Shield />
                            <Lock />
                            <span className="text-xs font-mono text-emerald-200">256-BIT ENCRYPTION DETECTED</span>
                        </div>
                    </div>

                    <div className="relative">
                        <div className="absolute inset-0 bg-[#34d399] opacity-10 blur-[100px] rounded-full"></div>
                        <div className="relative bg-[#064e3b]/50 border border-[#059669]/30 rounded-2xl p-8 backdrop-blur-sm">
                             <div className="flex justify-between items-center mb-8 border-b border-[#059669]/30 pb-4">
                                 <div>
                                     <div className="text-xs text-emerald-400 font-bold uppercase mb-1">Portfolio Value</div>
                                     <div className="text-3xl font-mono font-bold">$142,308.00</div>
                                 </div>
                                 <div className="px-3 py-1 bg-[#10b981]/20 text-[#34d399] rounded text-xs font-bold font-mono">
                                     +24.5%
                                 </div>
                             </div>
                             
                             <div className="space-y-4">
                                 <div className="h-2 bg-[#065f46] rounded-full overflow-hidden">
                                     <div className="h-full w-3/4 bg-[#34d399] rounded-full"></div>
                                 </div>
                                 <div className="flex justify-between text-xs text-emerald-200/60 font-mono">
                                     <span>MODULE 1</span>
                                     <span>COMPLETED</span>
                                 </div>
                                 
                                 <div className="h-2 bg-[#065f46] rounded-full overflow-hidden mt-6">
                                     <div className="h-full w-1/2 bg-[#34d399] rounded-full"></div>
                                 </div>
                                 <div className="flex justify-between text-xs text-emerald-200/60 font-mono">
                                     <span>MODULE 2</span>
                                     <span>IN PROGRESS</span>
                                 </div>
                             </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default FintechSecure;
